module.exports = __webpack_public_path__ + "img/others_15.e78aee69.jpg";